import { SearchableEntity } from "@ews-admin/global-design-system";

export const DEFAULT_PATIENT_IMAGE_MALE = "/image/manPatient.png";
export const DEFAULT_PATIENT_IMAGE_FEMALE = "/image/womanPatient.png";

import { Appointment } from "./appointment.definition";
import { UserInfo } from "./user.definition";

export type PublicPatient = SearchableEntity & {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  civility?: string;
  age?: number;
  photoUrl?: string;
  // MED-1687: sent by the patient search so the booking form can warn about a disabled account
  disabled?: boolean;
};

export type Patient = SearchableEntity &
  UserInfo & {
    age?: number;
    emergencyContacts?: EmergencyContact[];
    medicalHistory?: MedicalRecord[];
    upcomingAppointments?: Appointment[];
    alertSettings?: AlertSettings;
    lastVisit?: string;
    bloodType?: string;
    allergies?: string[];
    medications?: string[];
    healthcareFacilityIds?: string[];
    disabled?: boolean;
  };

export interface EmergencyContact {
  id?: string;
  firstName: string;
  lastName: string;
  relationship: string;
  phoneNumber: string;
  email?: string;
  priority: number;
}

export interface MedicalRecord {
  id: string;
  date: string;
  type:
  | "CONSULTATION"
  | "LAB_TEST"
  | "PRESCRIPTION"
  | "SURGERY"
  | "VACCINATION";
  doctor: string;
  diagnosis?: string;
  treatment?: string;
  notes?: string;
  attachments?: string[];
}

export interface AlertSettings {
  id: string;
  patientId: string;
  appointmentReminders: boolean;
  medicationReminders: boolean;
  followUpReminders: boolean;
  emergencyAlerts: boolean;
  emailNotifications: boolean;
  smsNotifications: boolean;
  reminderFrequency: "DAILY" | "WEEKLY" | "MONTHLY";
}
